import React, { FC, ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "components/common/ScrollToTop";

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col h-full min-h-screen mb-0">
      <ScrollToTop />

      <Navbar />
      <main className={`mt-20 md:mt-28 mb-10 flex-grow px-5 md:px-20 lg:px-52`}>{children}</main>
      <Footer />
    </div>
  );
};

export default AppLayout;
